import api from "../api";
import dates from "../services/dates";
import utils from "../services/utils";

const state = {
  activeTab: null,
  filters: {
    timeFrame: 'last_30',
    timeFrameValues: {
      start: dates.startOfLast30Days(),
      end: dates.endOfToday()
    },
    users: [],
  },
  chartBackgroundColors: [
    '#F25430',
    '#FFC400',
    '#4CAF50',
    '#318DDE',
    '#C62828',
    '#C5FF95',
    '#1C6C7D',
    '#891652',
    '#DB3052',
    '#7030C9',
    '#24B283',
    '#F79A36',
    '#FF76CE',
    '#94FFD8',
    '#332941',
    '#803D3B',
    '#8644A2',
    '#C6EBC5',
    '#114232',
    '#87A922',
  ],
}

const getters = {
  getFilters(state) {
    return state.filters
  },
  getActiveTab(state) {
    return state.activeTab
  },
  getChartBackgroundColors(state, getters, rootState, rootGetters) {
    return rootGetters.activeUsers.map((user, index) => {
      return {
        userId: user.id,
        color: state.chartBackgroundColors[index]
      }
    })
  }
}

const mutations = {
  setOneFilter(state, [filter, value]) {
    state.filters[filter] = value;
  },
  setActiveTab(state, tab) {
    state.activeTab = tab
  },
  reset(state) {
    // this should match the state filters
    state.filters = {
      timeFrame: 'last_30',
      timeFrameValues: {
        start: dates.startOfLast30Days(),
        end: dates.endOfToday()
      },
      users: []
    }
    state.activeTab = null
  },
}

const actions = {
  // setup({commit, state}) {
  //   commit('reset')
  // },
  // teardown({commit}) {
  //   commit('reset')
  // },
}

const StatsStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default StatsStore;
